import { render } from "./RelationshipStep.vue?vue&type=template&id=77bb96e7"
import script from "./RelationshipStep.vue?vue&type=script&lang=js"
export * from "./RelationshipStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__